import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { api } from '../../api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ab from '../../assets/img/About.png';
import ConsultationForm from './ConsultationForm';
import { useNavigate } from 'react-router-dom'; // Add this import

const About = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Select Your Industry');
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        industry: ''
    });
const navigate = useNavigate(); // Initialize the navigate function
    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setFormData({ ...formData, industry: option });
        setIsOpen(false);
    };

    const options = [
        'Solopreneurs',
        'Personal Training',
        'Beauty Spa',
        'Bakery & Spa',
        'Bakery & Cafe',
        'Consultancy',
        'Coaching Center',
        'Boutique Services',
        'Clinics & Medicals',
        'Other Services',
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/consultations', formData);
            console.log('Success:', response.data);
            toast.success('Consultation request submitted successfully!');
            setFormData({ name: '', phone: '', email: '', industry: '' });
            setSelectedOption('Select Your Industry');
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Error submitting form. Please try again.');
        }
    };

    return (
        <div className='mx-4 md:m-8 mt-20 md:mt-28'>
            <ToastContainer 
                position="top-right" 
                autoClose={5000} 
                hideProgressBar={false} 
                newestOnTop={false} 
                closeOnClick 
                rtl={false} 
                pauseOnFocusLoss 
                draggable 
                pauseOnHover 
                toastClassName="font-urbanist"
            />
            
            <div className='container mx-auto max-w-7xl'>
                <div className='flex flex-col lg:flex-row gap-8'>
                    {/* Left Column */}
                    <div className='flex-1'>
                        <div className='space-y-8'>
                            <div>
                                <h1 className='font-extrabold font-urbanist text-4xl md:text-5xl leading-tight mb-6'>
                                    Ato Creative! <span className='text-[#FD5F20]'>Our Name Has a Story.</span>
                                </h1>
                                <p className='font-urbanist text-gray-700 text-lg leading-relaxed mb-6'>
                                    Welcome to Ato Creative, a unique agency founded by three innovative minds. The term 'ato' holds significance in the Igbo language, meaning 'three', representing our founders. In Amharic, 'Ato' is a respectful term for a man. This mirrors our approach to creativity and design, emphasizing humility, respect, and collaboration. Join us at Ato Creative for projects fueled by cultural richness, collaborative effort, and boundless creativity.
                                </p>
                               <button 
                                    onClick={() => navigate('/OurStory')} // Add this onClick handler
                                    className='bg-[#FD5F20] hover:bg-[#e0551d] transition-colors duration-300 p-4 rounded-lg text-white font-medium flex items-center gap-2'
                                >
                                    <FontAwesomeIcon icon={faPlayCircle} />
                                    Watch Our Story
                                </button>
                            </div>
                            
                            {/* <div className='mt-12'>
                                <h1 className='text-4xl md:text-5xl font-bold mb-8 relative'>
                                    <span className='relative'>
                                        We Are
                                        <span className='absolute bottom-0 left-0 w-24 h-1 bg-[#FD5F20]'></span>
                                    </span>
                                </h1>
                                
                                <div className='grid gap-6 md:grid-cols-2'>
                                    <div className='bg-white p-6 rounded-xl  hover: transition-shadow duration-300'>
                                        <h2 className='font-bold text-xl mb-3'>Client-Centric</h2>
                                        <p className='text-gray-600'>Our clients' triumphs are our own. We tailor our services to their unique needs.</p>
                                    </div>
                                    
                                    <div className='bg-white p-6 rounded-xl  hover: transition-shadow duration-300'>
                                        <h2 className='font-bold text-xl mb-3'>Transparent & Integrative</h2>
                                        <p className='text-gray-600'>We operate with honesty and ethical behavior, fostering trust.</p>
                                    </div>
                                    
                                    <div className='bg-white p-6 rounded-xl  hover: transition-shadow duration-300'>
                                        <h2 className='font-bold text-xl mb-3'>Creative & Innovative</h2>
                                        <p className='text-gray-600'>We push boundaries with fresh ideas, driving success.</p>
                                    </div>
                                    
                                    <div className='bg-white p-6 rounded-xl  hover: transition-shadow duration-300'>
                                        <h2 className='font-bold text-xl mb-3'>Data-Driven</h2>
                                        <p className='text-gray-600'>Informed decisions from data analysis lead to optimized campaigns.</p>
                                    </div>
                                    
                                    <div className='bg-white p-6 rounded-xl  hover: transition-shadow duration-300 md:col-span-2'>
                                        <h2 className='font-bold text-xl mb-3'>Results-Oriented</h2>
                                        <p className='text-gray-600'>We focus on measurable outcomes for brand growth and revenue.</p>
                                    </div>
                                </div>
                            </div> */}
                             <h1 className='text-3xl md:text-4xl font-bold mb-6'>We take time to understand your Business</h1>
                                <p className='text-gray-600 mb-6 font-urbanist text-lg leading-relaxed'>
                                    We inspire you to discover the ideal niche for your business, create powerful messaging that resonates with your audience, and design a solution that captivates their attention. Together, we will craft compelling pitches that confidently present your solution to your target audience.
                                </p>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className='flex-1'>
                        <div className='sticky top-24 space-y-8'>
                            <div className='overflow-hidden rounded-xl '>
                                <img 
                                    src={ab} 
                                    className='w-full h-auto md:h-96 object-cover object-center transition-transform duration-500 hover:scale-105' 
                                    alt="About Us" 
                                />
                            </div>
                            
                            <div className='bg-white p-6 md:p-8 rounded-xl '>
                               
                                
                                <div className='bg-[#FFF5F1] p-6 rounded-lg border-l-4 border-[#FD5F20]'>
                                    <h2 className='text-2xl md:text-3xl font-bold mb-4 text-[#FD5F20]'>Act Now - Your Future Awaits!</h2>
                                    <ConsultationForm/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;